// component constant
export const MOST_RECENT_COMPONENT_COUNT = 10;

// redux

export const DELETE_CONTENT_OR_FOLDER_SUCCESS = 'user/DELETE_CONTENT_OR_FOLDER_SUCCESS';
export const FAVORITE_CONTENT_FULFILLED = 'user/FAVORITE_CONTENT_FULFILLED';
export const GET_USER_REQUESTED = 'user/GET_USER_REQUESTED';
export const GET_USER_REQUEST_FULFILLED = 'user/GET_USER_REQUEST_FULFILLED';
export const GET_USER_REQUEST_REJECTED = 'user/GET_USER_REQUEST_REJECTED';
export const SEARCH_MOST_RECENT_COMPONENTS_FULFILLED =
  'search/SEARCH_MOST_RECENT_COMPONENTS_FULFILLED';
export const SEARCH_MOST_RECENT_COMPONENTS_REJECTED =
  'search/SEARCH_MOST_RECENT_COMPONENTS_REJECTED';
